import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { AgentListView } from './agent-list.view';
import { AgentListDataService } from './agent-list.data';

interface Props extends ControllerProps<{}> {
	responsibleAgentId?: number;
}

@observer
export class AgentListController extends React.Component<Props, {}> {
	@resolve
	private toast: ToastNotifications;

	@observable
	dataService: AgentListDataService;

	constructor(props: Readonly<Props>) {
		super(props);
	}

	componentDidMount() {
		this.initialize(this.props.responsibleAgentId);
	}

	componentWillReceiveProps(nextProps: Readonly<Props>) {
		if (nextProps.responsibleAgentId !== this.props.responsibleAgentId) {
			this.initialize(nextProps.responsibleAgentId);
		}
	}

	private initialize(responsibleAgentId?: number): void {
		this.props.setBusy(true);
		this.loadData(responsibleAgentId)
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false)
			});
	}

	private async loadData(responsibleAgentId?: number): Promise<void> {
		this.dataService = AgentListDataService.make();

		if (responsibleAgentId) {
			this.dataService.addFilter('responsibleAgentId', 'eq', responsibleAgentId);
		}
		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.addSorting('id', 'asc', true);
		await this.dataService.load(query => query);
	}

	handleItemDoubleClick = (item: AgentSummary): void => {
		this.props.history.push(`/bookings/agents/${item == null ? 'new' : item.id}`);
	}

	render() {
		if (this.dataService == null) {
			return null;
		}

		const isReadonly = this.props.responsibleAgentId != null;

		return (
			<AgentListView
				model={this.dataService}
				isReadonly={isReadonly}
				onItemDoubleClicked={this.handleItemDoubleClick}
				setBusy={this.props.setBusy}
				{ ...this.props }
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agents/list/agent-list.controller.tsx